<template>
  <div class="AppInvoice_vue font-jumperlight">

    <b-container fluid class="mt-3 px-0">
      <b-row>
        <b-col cols="6">
          <div class="d-flex justify-content-between">
            <div class="d-flex justify-content-between w-100">
              <div class="position-absolute pt-2 pl-3 search-icon">
                <i class="fas fa-search"></i>
              </div>
              <b-form-input
                  debounce="600"
                  v-model="searchTerm"
                  class="w-100 search-bar position-relative"
                  placeholder="Partner vagy számlaszám"
                  style="padding-left: 45px !important;"
              ></b-form-input>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>

    <b-container fluid class="mt-3 px-0">
      <b-overlay :show="loading" rounded="sm" spinner-variant="success" spinner-type="grow">
        <div v-if="invoices && invoices.content && invoices.content.length > 0" class="mt-3">
          <div
              class="list-item my-2 d-flex p-3 mb-3"
              v-for="(item, index) in invoices.content"
              :key="'appInvoiceItem_' + index"
          >
            <b-container fluid>
              <div>
                <div class="list-label flex-fill">
                  <!--                {{ item }}-->
                  <b-row class="invoice-label" align-h="between" align-v="center">
                    <b-col class="col-12 col-md-4">
                      <div
                          v-if="direction === 'OUTBOUND'"
                          class="name-label ellipsis-overflow mr-4"
                      >
                        {{ item.customerName }}
                      </div>
                      <div
                          v-if="direction === 'INBOUND'"
                          class="name-label ellipsis-overflow"
                      >
                        {{ item.supplierName }}
                      </div>
                      <div class="small mb-2">
                        {{ item.invoiceNumber }}
                      </div>
                      <span class="rounded-pill border bg-white small px-2 py-1">
                        {{ item.issueDate }}
                      </span>
                    </b-col>
                    <b-col>
                      <div class="mt-2 mt-md-0">
                        <span class="rounded-pill border bg-white small px-2 py-1">
                          {{ getPaymentMethodDisplay(item.paymentMethod) }}
                        </span>
                      </div>
                    </b-col>
                    <b-col class="text-right mt-2 mt-md-0">
                      <div
                          class="ml-auto price-label text-nowrap"
                          :class="item.totalGross < 0 ? 'text-danger' : ''"
                      >
                        {{ Number(item.totalGross).toLocaleString("hu-HU") }}
                        {{ item.currency }}
                      </div>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </b-container>
          </div>
        </div>
        <div v-else class="mx-auto text-center mt-3">
          {{ searchTerm ? $cte("common.noSearchResult") + searchTerm : $cte("income.emptyIncomeList") }}
        </div>
      </b-overlay>

      <Paging
          v-if="invoices && invoices.content && invoices.content.length > 0"
          :item-per-page="itemPerPage"
          :total-rows="rowCount"
          @paging-change="updateTable"
      />
    </b-container>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import Paging from "@/components/Paging"; // Assuming Paging is in components folder
import Api from "@/api/server"; // Adjust path if necessary

export default {
  name: "AppInvoice",
  components: {
    Paging,
  },
  props: {
    companyId: {
      type: Number,
      required: true
    },
    source: {
      type: String,
      required: true,
      validator: function (value) {
        return ['SZAMLAZZ_HU', 'BILLINGO'].includes(value);
      }
    },
    direction: {
      type: String,
      required: true,
      validator: function (value) {
        return ['INBOUND', 'OUTBOUND'].includes(value);
      }
    }
  },
  data() {
    return {
      invoices: null,
      searchTerm: "",
      page: 1,
      offset: 10, // Corresponds to 'size' in API call
      rowCount: 1,
      loading: false,
      itemPerPage: 10, // Used by Paging component
      billingoPaymentMethodsHu: {
        szep_card: "SZÉP kártya",
        barter: "Barter",
        bankcard: "Bankkártya",
        cash: "Készpénz",
        payoneer: "Payoneer",
        elore_utalas: "Előre utalás",
        kompenzacio: "Kompenzáció",
        barion: "Barion",
        cash_on_delivery: "Utánvét",
        transferwise: "Wise (TransferWise)",
        coupon: "Kupon",
        online_bankcard: "Online bankkártya",
        upwork: "Upwork",
        other: "Egyéb",
        paypal: "PayPal",
        wire_transfer: "Átutalás",
      },
    };
  },
  methods: {
    getPaymentMethodDisplay(paymentMethod) {
      if (this.source === 'SZAMLAZZ_HU') {
        return paymentMethod;
      }
      if (this.source === 'BILLINGO') {
        return this.billingoPaymentMethodsHu[paymentMethod] || paymentMethod;
      }
      return paymentMethod;
    },
    updateTable(data) {
      this.page = data.pagingPage;
      this.offset = data.pagingOffset;
      this.loadInvoices();
    },
    loadInvoices() {
      if (!this.getActiveCompany) {
        // Handle case where active company is not available
        this.$toast.error({
          title: 'Hiba',
          message: 'Nincs kiválasztott cég.',
        });
        return;
      }

      this.loading = true;

      const requestParams = {
        companyId: this.companyId,
        source: this.source,
        page: this.page - 1, // Backend expects 0-indexed page, Paging component is 1-indexed
        size: this.offset,
        direction: this.direction,
        searchTerm: this.searchTerm, // Use searchTerm for filtering
      };

      Api.listAppInvoices(requestParams)
          .then((resp) => {
            this.loading = false;
            this.invoices = resp.data;
            this.rowCount = resp.data.totalNumberOfElements;
          })
          .catch((err) => {
            console.error("Failed to load invoices:", err);
            this.loading = false;
            this.$toast.error({
              title: 'Sikertelen lekérdezés',
              message: 'Az adatok betöltése sikertelen',
            });
          });
    },
  },
  created() {
    this.loadInvoices();
  },
  computed: {
    ...mapGetters("app", ["getActiveCompany"]),
  },
  watch: {
    searchTerm() {
      this.page = 1; // Reset page when search term changes
      this.loadInvoices();
    },
    companyId() {
      this.page = 1;
      this.loadInvoices();
    },
    source() {
      this.page = 1;
      this.loadInvoices();
    },
    direction() {
      this.page = 1;
      this.loadInvoices();
    },
    getActiveCompany: {
      handler() {
        this.page = 1;
        this.loadInvoices();
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.app-invoice {
  padding: 20px;
}

.name-label {
  font-size: 1.2rem;
}

.price-label {
  font-size: 1.3rem;
  margin-top: 0.4rem;
}

@media screen and (max-width: 768px) {
  .price-label {
    font-size: 1.2rem;
    margin-top: 0.2rem;
  }
}

.ellipsis-overflow {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.search-icon {
  color: gray;
  font-size: 1.3rem;
}

.search-bar {
  color: #000000 !important;
  background-color: #ffffff !important;
  border: 1px solid rgb(222, 226, 230) !important;
}

.list-item {
  background-color: #AEBFC7;
  border: none !important;
  box-shadow: 0px 20px 30px 0px rgba(0, 0, 0, 0.10) !important;
}
</style>
